import { useState } from "react";
import { Menu, MenuItem, ListItemIcon } from "../../../../components";
import { HistoricoContas } from "./";
import shortid from "shortid";

const MenuAddActions = ({ anchorEl, setAnchorEl, pessoa }) => {
  const [openHistorico, setOpenHistorico] = useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "primary-add-actions-menu";

  const handleAddActionsClose = () => {
    setAnchorEl(null);
  };

  const handleHistorico = () => {
    setOpenHistorico(!openHistorico);
    handleAddActionsClose();
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        elevation={1}
        getContentAnchorEl={null}
        id={menuId}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        autoFocus={false}
        open={isMenuOpen}
        onClose={handleAddActionsClose}
        className="m-3"
      >
        {[
          <MenuItem
            className="mb-1"
            onClick={handleHistorico}
            sx={{ height: 20, borderRadius: 5 }}
            key={shortid.generate()}
          >
            <ListItemIcon style={{ minWidth: 42 }}>
              <i className="ph-fill ph-money" style={{ fontSize: 16 }}></i>
            </ListItemIcon>
            <span style={{ fontSize: 12 }}>Visualizar Contas</span>
          </MenuItem>,
        ]}
      </Menu>
      <HistoricoContas
        openHistorico={openHistorico}
        setOpenHistorico={setOpenHistorico}
        handleHistorico={handleHistorico}
        pessoa={pessoa}
      />
    </>
  );
};

export default MenuAddActions;
